module.exports = __webpack_public_path__ + "static/media/AirbnbCerealApp-Bold.c0bb2554.woff";